import { FileStats } from '@/types';
import Typography from 'antd/lib/typography';
import { antGrey, antRed } from '@/components/styles/globalStyles';
import { iconForFileType } from '@/helpers/fileDisplayHelpers';
import { formatBytes } from '@/helpers';
import Popconfirm from 'antd/lib/popconfirm';
import Button from 'antd/lib/button';
import { DeleteOutlined } from '@ant-design/icons';
import * as React from 'react';

interface DeleteActionProps {
    fileStats: FileStats;
    isLoading: boolean;
    handleDelete: (fileName: string) => void;
    removeButtonText: string;
    confirmationMessage: string;
    confirmationAcceptText: string;
    confirmationCancelText: string;
}

export const FileDeleteDialog = ({
    fileStats,
    isLoading,
    handleDelete,
    removeButtonText,
    confirmationCancelText,
    confirmationAcceptText,
    confirmationMessage,
}: DeleteActionProps) => {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                marginTop: 24,
                marginBottom: 24,
            }}
        >
            <Typography.Paragraph key={fileStats.fileName} style={{ color: antGrey.grey9, marginBottom: 0 }}>
                <Typography.Text>
                    {iconForFileType(fileStats.fileName)} {fileStats.fileName}
                </Typography.Text>{' '}
                <Typography.Text>({formatBytes(fileStats.fileSize)})</Typography.Text>
            </Typography.Paragraph>
            <Popconfirm
                placement="top"
                title={confirmationMessage}
                onConfirm={() => handleDelete(fileStats.fileName)}
                okText={confirmationAcceptText}
                okButtonProps={{ loading: isLoading }}
                cancelText={confirmationCancelText}
            >
                <Button
                    type="text"
                    icon={<DeleteOutlined style={{ color: antRed.red4 }} />}
                    style={{ color: antRed.red5, display: 'flex', alignItems: 'center' }}
                    loading={isLoading}
                >
                    {removeButtonText}
                </Button>
            </Popconfirm>
        </div>
    );
};
